import { createTheme, responsiveFontSizes } from '@mui/material/styles'
import type { ThemeOptions } from '@mui/material/styles'
import type { ThemeMode } from '../hooks/useThemeMode'

export const createAppTheme = (mode: ThemeMode) => {
  const baseOptions: ThemeOptions = {
    palette: {
      mode,
      primary: { main: '#667eea' },
      secondary: { main: '#764ba2' },
      background:
        mode === 'dark'
          ? { default: '#0b0d16', paper: 'rgba(255,255,255,0.06)' }
          : { default: '#f6f7fb', paper: '#ffffff' },
    },
    spacing: 10,
    typography: {
      fontFamily: 'Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
      h1: { fontSize: '3rem', fontWeight: 800, letterSpacing: '-0.02em' },
      h2: { fontSize: '2.25rem', fontWeight: 700, letterSpacing: '-0.01em' },
      h3: { fontSize: '1.875rem', fontWeight: 700 },
      h4: { fontSize: '1.5rem', fontWeight: 700 },
      h5: { fontSize: '1.25rem', fontWeight: 600 },
      h6: { fontSize: '1.125rem', fontWeight: 600 },
      button: { fontWeight: 600 },
      subtitle1: { letterSpacing: 0.15 },
      body1: { lineHeight: 1.7 },
    },
    shape: { borderRadius: 12 },
    components: {
      MuiContainer: {
        defaultProps: { maxWidth: 'xl' },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backdropFilter: mode === 'dark' ? 'blur(8px)' : undefined,
            border: mode === 'dark'
              ? '1px solid rgba(255,255,255,0.08)'
              : '1px solid rgba(0,0,0,0.06)',
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            backdropFilter: mode === 'dark' ? 'blur(6px)' : undefined,
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: 'none',
            borderRadius: 10,
          },
        },
      },
    },
  }

  const theme = createTheme(baseOptions)
  return responsiveFontSizes(theme)
}

